import cloneDeep from 'lodash/cloneDeep'

export default {
    state: {
        users: [],
    },
    mutations: {
        setUsers(state, users) {
            state.users = users
        },
        addUser(state, user) {
            state.users.push(user)
        },
        updateUser(state, user) {
            const index = state.users.findIndex(item => item.id === user.id)
            Vue.set(state.users, index, user)
        },
        removeUser(state, userId) {
            state.users = state.users.filter(item => item.id !== userId)
        },
    },
    getters: {
        listUsers: state => cloneDeep(state.users).map(item => {
            switch (item.role) {
                case 'admin':
                    item.role = 'Administrator'
                    break;

                default:
                    item.role = 'Bruger'
                    break;
            }
            return item
        }),
        findUser: state => id => state.users.find(item => item.id === id)
    },
    actions: {
        loadUsers(context) {
            window.axios.get('/api/settings/users')
                .then(({data}) => {
                    context.commit('setUsers', data)
                })
                .catch(error => console.error(error))
        },
        addUser(context, payload) {
            context.commit('addUser', payload)
        },
        updateUser(context, payload) {
            context.commit('updateUser', payload)
        },
        removeUser(context, userId) {
            context.commit('removeUser', userId)
        },
    }
}
